module.exports = {};

module.exports.profile = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    profile: '/consumer/profile/me/',
    setNewPasswordRequest: '/consumer/update_password_request/',
    setNewPasswordConfirm: '/consumer/update_password_request/{id}/',
    setNewEmailRequest: '/consumer/update_email/',
    setNewEmailConfirm: '/consumer/update_email/{id}/',
    setNewEmailVerify: '/consumer/update_email/{token}/verify/',
    emailVerification: '/verification/email/{token}/',
    resendVerificationEmail: '/verification/email/',
  },
};

module.exports.registration = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    create: '/consumer/registration/',
    update: '{url}',
    validate: '{url}validate/',
    verify: '{url}verify/',
  },
};

module.exports.recovery = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    init: '/consumer/password-recovery-request/',
    confirmOtp: '{url}',
    setNewPassword: '{url}verify/',
  },
};
